import {
    Box,
    Container,
    Grid,
    Link,
    List,
    ListItem,
    ListItemText,
    Typography,
} from "../../../../components/ui/LayoutPrimitives";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../../../../api/action/products";
import { Link as RouterLink } from "react-router-dom";
import SocialIcons from "../../../../assets/SocialIcons";

const SunFlareTemplateFooter = ({ company }) => {
    const companyState = useSelector((state) => state.companyReducer.company);
    const resolvedCompany = { ...(companyState || {}), ...(company || {}) };
    const companyPrimaryId = resolvedCompany?.primaryId || resolvedCompany?.companyId || resolvedCompany?.id;
    const companyOperatingLocation = resolvedCompany?.operatingLocation?.code;
    const phoneNumber = resolvedCompany?.contactPerson?.phoneNumber || "(678) 855-6990";
    const code = companyOperatingLocation || "";

    function assignCountryCode(code) {
        return code === "US" ? "+1" : code === "IND" ? "+91" : "+1";
    }

    const countryCode = assignCountryCode(code);
    const dispatch = useDispatch();
    const [categories, setCategories] = useState([]);


    useEffect(() => {
        const fetchProducts = async () => {
            if (!companyPrimaryId) {
                setCategories([]);
                return;
            }

            try {
                const response = await getAllProducts(companyPrimaryId)(dispatch);
                const uniqueCategories = [...new Set(
                    (Array.isArray(response) ? response : [])
                        .map((product) => product?.category?.name)
                        .filter(Boolean)
                )];
                setCategories(uniqueCategories.slice(0, 6));
            } catch {
                setCategories([]);
            }
        };

        fetchProducts();
    }, [companyPrimaryId, dispatch]);

    return (
        <Box
            component="footer"
            sx={{
                bgcolor: "#836932",
                color: "white",
                py: 6,
                mt: 8,
                textTransform: "capitalize",
            }}
        >
            <Container maxWidth="xl">
                <Grid container spacing={4}>
                    {categories.length > 0 && (
                        <Grid item xs={12} sm={6} md={3}>
                            <Box p={3}>
                                <Typography variant="h6" sx={{ fontWeight: "bold" }}>Online Shopping</Typography>
                                <List>
                                    {categories.map((category, index) => (
                                        <ListItem key={index} disableGutters>
                                            <ListItemText
                                                primary={
                                                    <Link href="#" underline="hover" sx={{ color: "white", "&:hover": { color: "#977d40" } }}>
                                                        {category}
                                                    </Link>
                                                }
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                        </Grid>
                    )}
                    <Grid item xs={12} sm={6} md={3}>
                        <Box p={3}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>Useful Links</Typography>
                            <List>
                                {["Blog", "Careers", "Site Map", "Corporate Info", "Whitehat", "Cleartrip"].map((text) => (
                                    <ListItem key={text} disableGutters>
                                        <ListItemText
                                            primary={
                                                <Link href="#" underline="hover" sx={{ color: "white", "&:hover": { color: "#977d40" } }}>
                                                    {text}
                                                </Link>
                                            }
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Box p={3}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>Customer Policies</Typography>
                            <List>
                                {resolvedCompany?.dynamicAttributes
                                    ?.filter(attr => attr.name === "terms_and_condition")
                                    .map((attr) => (
                                        <ListItem key={attr.name} disableGutters>
                                            <ListItemText
                                                primary={
                                                    <Link
                                                        component={RouterLink}
                                                        to={`/policy/${attr.name}`}
                                                        underline="hover"
                                                        sx={{ color: "white", "&:hover": { color: "#977d40" } }}
                                                    >
                                                        Terms & Conditions
                                                    </Link>
                                                }
                                            />
                                        </ListItem>
                                    ))}
                            </List>
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <Box p={3}>
                            <Typography variant="h6" sx={{ fontWeight: "bold" }}>Keep In Touch</Typography>
                            <SocialIcons />
                            <Typography variant="body1" sx={{ mt: 2 }}>
                                <Link href={`tel:${phoneNumber}`} underline="hover" sx={{ color: "white", "&:hover": { color: "#977d40" } }}>
                                    {countryCode} {phoneNumber}
                                </Link>
                            </Typography>
                            <Typography variant="body2" sx={{ color: "white", "&:hover": { color: "#977d40" } }}>
                                {resolvedCompany?.contactPerson?.email || "system@avpstech.com"}
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default SunFlareTemplateFooter;
